import { useContext } from 'react';

import BpkBreakpoint, {
  BREAKPOINTS,
} from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';
import {
  BpkBox,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';

import StringsContext from '../Contexts/StringsContext';
import FlightEntry from '../FlightEntry';
import FlightListStatus from '../FlightListStatus';
import PlaceholderFlightEntry from '../PlaceholderFlightEntry';

import type { FlightEntryData } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ArrivalsDepartures';

interface FlightEntryListProps {
  entries: FlightEntryData[];
  error?: boolean;
  onRetryButtonClick?: () => void;
  loaded: boolean;
  isFiltering?: boolean;
  showFlightTrackerLinks?: boolean;
  flightTrackerBasePath?: string;
  useUMSFlightTrackerUrls?: boolean;
}

const FlightEntryList = ({
  entries,
  error = undefined,
  flightTrackerBasePath = undefined,
  isFiltering = false,
  loaded,
  onRetryButtonClick = undefined,
  showFlightTrackerLinks = false,
  useUMSFlightTrackerUrls = false,
}: FlightEntryListProps) => {
  const strings = useContext(StringsContext);

  if (!loaded) {
    return (
      <BpkBox
        data-testid="flight-entry-list-loading"
        paddingBottom={BpkSpacing.LG}
      >
        {Array.from({ length: 20 }).map((_e, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <PlaceholderFlightEntry key={i} />
        ))}
      </BpkBox>
    );
  }

  if (error) {
    return (
      <FlightListStatus
        message={strings.falcon_adb_error_message}
        buttonText={
          strings.falcon_arrivals_departures_board_flightStatus_tryAgain
        }
        onButtonClick={onRetryButtonClick}
        error
      />
    );
  }

  if (isFiltering && entries.length === 0) {
    return (
      <FlightListStatus message={strings.falcon_adb_empty_filtered_results} />
    );
  }

  if (entries.length === 0) {
    return <FlightListStatus message={strings.falcon_adb_error_message} />;
  }

  return (
    <BpkBreakpoint query={BREAKPOINTS.SMALL_TABLET}>
      {(isMobile: boolean) => (
        <>
          {entries.map((entry) => (
            <FlightEntry
              isMobile={isMobile}
              key={entry.id}
              showFlightTrackerLinks={showFlightTrackerLinks}
              flightTrackerBasePath={flightTrackerBasePath}
              useUMSFlightTrackerUrls={useUMSFlightTrackerUrls}
              {...entry}
            />
          ))}
        </>
      )}
    </BpkBreakpoint>
  );
};
export default FlightEntryList;
